import { render, staticRenderFns } from "./ReviewsButtons.vue?vue&type=template&id=21fe7a29&"
import script from "./ReviewsButtons.vue?vue&type=script&lang=js&"
export * from "./ReviewsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fe7a29')) {
      api.createRecord('21fe7a29', component.options)
    } else {
      api.reload('21fe7a29', component.options)
    }
    module.hot.accept("./ReviewsButtons.vue?vue&type=template&id=21fe7a29&", function () {
      api.rerender('21fe7a29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/ReviewsButtons.vue"
export default component.exports